import { useMemo } from "react";
import { PortalAuthClientWithSelfUI } from "@/lib/portalAuthClient";

/**
 * 1コンポーネントにつき1インスタンスの PortalAuthClient を返すカスタムフック
 */
export const usePortalAuthClient = () => {
  const client = useMemo(() => new PortalAuthClientWithSelfUI(), []);
  return client;
};
